"use client"

import { motion } from "framer-motion"
import Link from "next/link"

const steps = [
  {
    num: "01",
    title: "Upload your conversations",
    detail: "ChatGPT, Claude, Gemini — or any text.",
  },
  {
    num: "02",
    title: "We find the patterns",
    detail: "No humans see your data. Ever.",
  },
  {
    num: "03",
    title: "Meet yourself",
    detail: "Your portrait. Five written lenses into how you think.",
  },
]

export function HowItWorks() {
  return (
    <section className="px-6 py-20">
      <div className="mx-auto max-w-4xl">
        <motion.h2
          className="text-center font-[var(--font-instrument-serif)] text-3xl font-normal sm:text-4xl"
          style={{ color: "var(--brand-graphite)" }}
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
        >
          Three steps. Zero surveys.
        </motion.h2>

        <div className="mt-14 grid gap-6 sm:grid-cols-3">
          {steps.map((step, i) => (
            <motion.div
              key={step.num}
              className="rounded-xl border border-[var(--border-subtle)] bg-white p-6"
              style={{ boxShadow: "var(--shadow-card)" }}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.5, delay: i * 0.1 }}
            >
              <span
                className="text-3xl font-light"
                style={{ color: "var(--brand-star)" }}
              >
                {step.num}
              </span>
              <h3
                className="mt-4 text-lg font-semibold"
                style={{ color: "var(--brand-graphite)" }}
              >
                {step.title}
              </h3>
              <p
                className="mt-2 text-sm leading-relaxed"
                style={{ color: "var(--brand-cliff)" }}
              >
                {step.detail}
              </p>
            </motion.div>
          ))}
        </div>

        <motion.div
          className="mt-10 text-center"
          initial={{ opacity: 0 }}
          whileInView={{ opacity: 1 }}
          viewport={{ once: true }}
          transition={{ duration: 0.5, delay: 0.4 }}
        >
          <Link
            href="/science"
            className="text-sm font-medium transition-colors hover:opacity-70"
            style={{ color: "var(--brand-cobalt)" }}
          >
            How does it work?
          </Link>
        </motion.div>
      </div>
    </section>
  )
}
